import { create } from "zustand"
import { persist } from "zustand/middleware"
import type { FilterCategory } from "./ExpandedSearchSidebar"
import type { ExpandedSearchRecentSearch } from "./recent-searches/types"

const RECENT_SEARCHES_MAX_COUNT = 3

type ExpandedSearchStore = {
  open: boolean
  setOpen: (open: boolean) => void

  loading: boolean
  setLoading: (loading: boolean) => void

  selectedCategory: FilterCategory
  setSelectedCategory: (category: FilterCategory) => void

  searchQuery: string
  setSearchQuery: (query: string) => void

  recentSearches: ExpandedSearchRecentSearch[]
  pushRecentSearch: (
    recentSearch: Omit<ExpandedSearchRecentSearch, "timestamp">,
  ) => void
  clearRecentSearches: () => void
}

export const useExpandedSearchStore = create<ExpandedSearchStore>()(
  persist(
    (set, get) => ({
      open: false,
      setOpen: open => {
        set({ open })
      },

      loading: false,
      setLoading: loading => {
        set({ loading })
      },

      selectedCategory: "all",
      setSelectedCategory: category => {
        set({ selectedCategory: category })
      },

      searchQuery: "",
      setSearchQuery: query => {
        set({ searchQuery: query })
      },

      recentSearches: [],
      pushRecentSearch: recentSearch => {
        const { recentSearches } = get()

        set({
          recentSearches: [
            ...recentSearches
              .filter(rs => rs.key !== recentSearch.key)
              .slice(-(RECENT_SEARCHES_MAX_COUNT - 1)),
            {
              ...recentSearch,
              timestamp: Date.now(),
            } as ExpandedSearchRecentSearch,
          ],
        })
      },
      clearRecentSearches: () => {
        set({ recentSearches: [] })
      },
    }),
    {
      name: "expanded-search",
      partialize: state => ({
        recentSearches: state.recentSearches,
      }),
    },
  ),
)
